export default "__VITE_ASSET__D$_jwU30__"